import { useAuth } from "@/context/AuthContext";
import { PlanCards, ServiceCards } from "@/components/fo/PlanCards";
import { SectionHead } from "@/components/fo/Bits";

export default function Pricing() {
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-7xl px-4 pb-24 pt-28 md:px-8" data-testid="pricing-page">
      <SectionHead label="Plans" title="Pay for more plays, never for access">
        Every artist is selected by our team — paying doesn't get you in, it gets you heard more. Guaranteed plays are counted and shown in your report, play by play.
      </SectionHead>
      <PlanCards current={user?.effective_plan} />
      <div className="mt-24">
        <SectionHead label="One-off services" title="Extra spotlight, when you need it">Available on every plan, including Free. We deliver, you share.</SectionHead>
        <ServiceCards />
      </div>
    </div>
  );
}
